import { useSelector, useDispatch } from 'react-redux';
import { useState } from 'react';
import { Modal, Tag, Input } from 'antd';
import { IoArrowBackOutline } from '@react-icons/all-files/io5/IoArrowBackOutline';
import { setModalState } from '../../../../reducers/Modal/actions';
import {
  setSelectedOfferForContact,
  setSelectedOffer,
} from '../../../../reducers/Offer/actions';
import { MODAL_CONTACT_SPECIALIST } from '../../../../reducers/Modal/types';
import { ZorbaButton } from '../../../../components/forms';
import { BUTTON_VARIANT_DARK } from '../../../../components/forms/ZorbaButton/constants';
import { showErrorToast } from '../../../../services/notificationsService';
import { postRequest } from '../../../../services/requestService';

import './index.scss';
import { setSelectedPreDeal } from '../../../../reducers/PreDeals/actions';

export const ContactSpecialistModal = () => {
  const dispatch = useDispatch();
  const [textAreaValue, setTextAreaValue] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isMessageSent, setIsMessageSent] = useState(false);

  const { isContactSpecialistModalOpen } = useSelector(
    ({ ModalReducer }) => ModalReducer,
  );
  const { selectedOfferForContact } = useSelector(
    ({ OfferReducer }) => OfferReducer,
  );

  const isPreDeal = selectedOfferForContact?.isPreDeal;

  const handleCloseModal = async () => {
    dispatch(setSelectedOfferForContact());
    if (isPreDeal) {
      dispatch(setSelectedPreDeal(selectedOfferForContact));
    } else {
      dispatch(setSelectedOffer(selectedOfferForContact));
    }
    setIsMessageSent(false);
    setTextAreaValue('');
    dispatch(setModalState(MODAL_CONTACT_SPECIALIST, false));
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    try {
      await postRequest('/offer/talk-to-advisor', {
        message: textAreaValue,
        dealSubmissionId: selectedOfferForContact?.dealSubmission?._id,
        ...(isPreDeal ? { preDealId: selectedOfferForContact._id } : {}),
      });
      setIsMessageSent(true);
    } catch (error) {
      showErrorToast('Submitting contact request failed!');
    }
    setIsLoading(false);
  };

  return (
    <Modal
      open={isContactSpecialistModalOpen}
      footer={null}
      className="contact-modal"
      destroyOnClose
      onCancel={handleCloseModal}
      width="650px"
      closable={false}
    >
      <div className="modal-content">
        <div className="arrow-back">
          <IoArrowBackOutline
            size={30}
            onClick={handleCloseModal}
            className="icon"
          />
        </div>
        <div className="content-container">
          <div className="header">
            <div className="title-container">
              <span className="title">Contact market specialist</span>
              <span className="address">
                {isPreDeal
                  ? selectedOfferForContact?.address?.formattedAddress
                  : selectedOfferForContact?.dealSubmission?.address
                      ?.formattedAddress}
              </span>
            </div>
            {isPreDeal && (
              <div className="badge-container">
                <Tag className="badge">Pre-lock property</Tag>
              </div>
            )}
          </div>
          {isMessageSent ? (
            <>
              <div className="text-container">
                <span>Thank you for your inquiry!</span>
                <span> Our team will contact you shortly.</span>
              </div>
              <div className="button-container">
                <ZorbaButton
                  variant={BUTTON_VARIANT_DARK}
                  fullWidth={false}
                  onClick={handleCloseModal}
                >
                  Update your offer
                </ZorbaButton>
              </div>
            </>
          ) : (
            <>
              <div className="text-area-container">
                <span className="text-area-label">Your message</span>
                <Input.TextArea
                  placeholder="I am interested in 211 Chesapeake Way, Marinate, GA 30065..."
                  onChange={(e) => setTextAreaValue(e.target.value)}
                  value={textAreaValue}
                />
              </div>
              <div className="button-container">
                <ZorbaButton
                  variant={BUTTON_VARIANT_DARK}
                  fullWidth={false}
                  disabled={!textAreaValue || isLoading}
                  loading={isLoading}
                  onClick={handleSubmit}
                >
                  Contact Marketplace Specialist
                </ZorbaButton>
                <span className="button-description">
                  By pressing Contact marketplace specialist, you agree that
                  Zorba and its affiliates may call/text you about your inquiry,
                  which may involve use of automated means and
                  prerecorded/artificial voices.
                </span>
              </div>
            </>
          )}
        </div>
      </div>
    </Modal>
  );
};
